import { faker } from '@faker-js/faker/locale/es';
import type { InventoryRow, Product } from './types';

const RAW_MATERIALS = [
  { sku: 'MAT-AL-6061', description: 'Aluminio 6061-T6 chapa', unit: 'kg' },
  { sku: 'MAT-ST-304',  description: 'Acero inoxidable 304 barra', unit: 'kg' },
  { sku: 'MAT-FE-S235', description: 'Acero S235JR perfil', unit: 'kg' },
  { sku: 'MAT-CU-99',   description: 'Cobre electrolítico 99.9%', unit: 'kg' },
];

const CONSUMIBLES = [
  { sku: 'CNS-WIRE-MIG', description: 'Hilo MIG ER70S-6 1.0mm', unit: 'rollo' },
  { sku: 'CNS-LUB-ISO46', description: 'Lubricante ISO VG 46', unit: 'L' },
  { sku: 'CNS-DRILL-12', description: 'Broca HSS Ø12mm', unit: 'pcs' },
  { sku: 'CNS-PAINT-RAL5010', description: 'Pintura epoxy RAL 5010', unit: 'L' },
  { sku: 'CNS-GLOVE-NITRIL', description: 'Guantes nitrilo talla L', unit: 'caja' },
];

const LOCATIONS = [
  'WH-A-01', 'WH-A-02', 'WH-A-03',
  'WH-B-01', 'WH-B-02', 'WH-B-03',
  'WH-C-01', 'WH-C-02',
  'WH-D-01', 'WH-D-02',
];

export function generateInventory(products: Product[], count: number = 200): InventoryRow[] {
  const rows: InventoryRow[] = [];

  // Raw materials
  for (const m of RAW_MATERIALS) {
    const physical = faker.number.int({ min: 200, max: 4000 });
    rows.push({
      sku: m.sku,
      description: m.description,
      location: faker.helpers.arrayElement(LOCATIONS),
      physicalQty: physical,
      reservedQty: Math.floor(physical * faker.number.float({ min: 0.1, max: 0.7 })),
      unit: m.unit,
      family: 'raw',
      reorderPoint: Math.floor(physical * 0.2),
    });
  }

  // Consumibles
  for (const c of CONSUMIBLES) {
    const physical = faker.number.int({ min: 5, max: 200 });
    rows.push({
      sku: c.sku,
      description: c.description,
      location: faker.helpers.arrayElement(LOCATIONS),
      physicalQty: physical,
      reservedQty: faker.number.int({ min: 0, max: Math.floor(physical * 0.5) }),
      unit: c.unit,
      family: 'consumible',
      reorderPoint: Math.floor(physical * 0.25),
    });
  }

  // Finished/semi-finished products
  const remaining = Math.max(0, count - rows.length);
  for (let i = 0; i < remaining; i++) {
    const product = products[i % products.length];
    const physical = faker.number.int({ min: 0, max: 500 });
    rows.push({
      sku: product.sku,
      description: product.description,
      location: faker.helpers.arrayElement(LOCATIONS),
      physicalQty: physical,
      reservedQty: faker.number.int({ min: 0, max: Math.floor(physical * 0.6) }),
      unit: 'pcs',
      family: product.family,
      reorderPoint: Math.floor(physical * 0.15) || 5,
    });
  }

  return rows;
}
